<span [class]="size === 'default' ? 'loader' : 'loader_line'" [style.margin]="margin"></span>
